import React, { memo, forwardRef } from "react";
const SvgNumbersix = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.4 13.76l.02.02c.187-.08.42-.14.7-.18.293-.04.56-.06.8-.06.627 0 1.213.12 1.76.36a4.398 4.398 0 011.44.96c.413.4.733.88.96 1.44.24.547.36 1.14.36 1.78 0 .747-.133 1.427-.4 2.04a4.743 4.743 0 01-1.1 1.58c-.453.427-1 .753-1.64.98a5.6 5.6 0 01-2.02.36c-.747 0-1.433-.12-2.06-.36a5.21 5.21 0 01-1.64-1.04 4.86 4.86 0 01-1.1-1.54c-.253-.6-.38-1.24-.38-1.92 0-.4.027-.773.08-1.12.067-.36.16-.707.28-1.04a9.34 9.34 0 01.46-.98c.187-.333.4-.68.64-1.04l3.3-4.96c.187-.28.373-.467.56-.56.187-.093.373-.14.56-.14.333 0 .613.107.84.32.24.2.36.473.36.82 0 .107-.027.24-.08.4-.04.16-.133.34-.28.54l-2.42 3.34zm-1.86 4.48c0 .373.06.727.18 1.06.133.333.32.627.56.88.24.253.527.453.86.6.333.147.707.22 1.12.22.813 0 1.467-.253 1.96-.76.507-.52.76-1.2.76-2.04 0-.4-.067-.767-.2-1.1-.12-.347-.3-.64-.54-.88a2.53 2.53 0 00-.86-.56c-.32-.147-.68-.22-1.08-.22s-.773.067-1.12.2a2.596 2.596 0 00-.88.58 2.49 2.49 0 00-.56.88c-.133.347-.2.727-.2 1.14z"
      />
    </svg>
  );
});
SvgNumbersix.displayName = "SvgNumbersix";
const MemoForwardRef = memo(SvgNumbersix);
export default MemoForwardRef;
